import { Injectable, Signal } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable } from 'rxjs';

import {
  FilteringConfig,
  FilterOptions,
  GridConfig,
} from '@customer-portal/shared';

import { SaveSiteNicknamePayload, SettingsSitesItemModel } from '../../models';
import {
  LoadSettingsSitesList,
  ResetSitesListState,
  SelectSiteForNickname,
  SubmitSiteNickname,
  UpdateSitesGridConfig,
} from '../actions';
import { SettingsSitesSelectors } from '../selectors';

@Injectable()
export class SitesStoreService {
  constructor(private store: Store) {}

  get settingsSitesList() {
    return this.store.selectSignal(SettingsSitesSelectors.settingsSitesList);
  }

  get selectedSite(): Signal<SettingsSitesItemModel | null> {
    return this.store.selectSignal(SettingsSitesSelectors.selectedSite);
  }

  get sitesGridConfig(): Signal<GridConfig> {
    return this.store.selectSignal(SettingsSitesSelectors.sitesGridConfig);
  }

  get sitesTotalFilteredRecords(): Signal<number> {
    return this.store.selectSignal(
      SettingsSitesSelectors.sitesTotalFilteredRecords,
    );
  }

  get hasSitesActiveFilters(): Signal<boolean> {
    return this.store.selectSignal(
      SettingsSitesSelectors.hasSitesActiveFilters,
    );
  }

  get sitesFilterOptions(): Signal<FilterOptions> {
    return this.store.selectSignal(SettingsSitesSelectors.sitesFilterOptions);
  }

  get sitesFilteringConfig(): Observable<FilteringConfig> {
    return this.store.select(SettingsSitesSelectors.sitesFilteringConfig);
  }

  get isSiteNicknameSubmitting(): Signal<boolean> {
    return this.store.selectSignal(
      SettingsSitesSelectors.isSiteNicknameSubmitting,
    );
  }

  get siteNicknameError(): Signal<string | null> {
    return this.store.selectSignal(SettingsSitesSelectors.siteNicknameError);
  }

  @Dispatch()
  loadSettingsSitesList = () => new LoadSettingsSitesList();

  @Dispatch()
  updateSitesGridConfig = (gridConfig: GridConfig) =>
    new UpdateSitesGridConfig(gridConfig);

  @Dispatch()
  resetSitesListState = () => new ResetSitesListState();

  @Dispatch()
  selectSiteForNickname = (siteId: string | number | null) =>
    new SelectSiteForNickname(siteId);

  submitSiteNickname(payload: SaveSiteNicknamePayload): Observable<void> {
    return this.store.dispatch(new SubmitSiteNickname(payload));
  }
}
